import Phaser from 'phaser';

export default class PatternMaker {

  constructor() {
    this.multipliers = [1,2,3,4,5,6,7,8,9,10];
  }

  getPattern (roundNum) {
    const patternArray = [];

    const m = this.multipliers.splice(Phaser.Math.Between(0,this.multipliers.length - 1),1);
    let i = 1;
    while (i < 11) {
      const patternObj = { val: i * m, filled: true };
      patternArray.push(patternObj);
      i++;
    }

    let spaces = roundNum;
    while (spaces > 0) {
      // remove random card
      const removeIndex = Phaser.Math.Between(0,patternArray.length - 1);
      if (patternArray[removeIndex].filled === true) {
        patternArray[removeIndex].filled = false;
        spaces--;
      }
    }

    return patternArray;
  }

  replacePattern (mNum) {
    this.multipliers.push(mNum);
  }
}